import type { ReactNode } from "react";

export interface Tab {
  key: string;
  label: string;
}

interface Props {
  tabs: Tab[];
  active: string;
  onChange: (key: string) => void;
  children: ReactNode;
}

export function Tabs({ tabs, active, onChange, children }: Props) {
  return (
    <>
      <div className="tabs">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            className={"tab-btn" + (active === t.key ? " is-active" : "")}
            onClick={() => onChange(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {children}
    </>
  );
}

export function TabPane({ active, when, children }: { active: string; when: string; children: ReactNode }) {
  return (
    <div className={"tab-pane" + (active === when ? " is-active" : "")} style={{ display: active === when ? undefined : "none" }}>
      {children}
    </div>
  );
}
